import { cid } from './env.mjs';

/**
 * @module @mkt-common/shopee-common
 */
const INS_HOMEPAGE_ALL = {
    sg: 'https://www.instagram.com/Shopee_SG/',
    tw: 'https://www.instagram.com/Shopee_TW/',
    my: 'https://www.instagram.com/Shopee_MY/',
    id: 'https://www.instagram.com/Shopee_ID/',
    ph: 'https://www.instagram.com/Shopee_PH/',
    th: 'https://www.instagram.com/Shopee_TH/',
    vn: 'https://www.instagram.com/Shopee_SG/',
    br: 'https://www.instagram.com/Shopee_BR/',
    mx: 'https://www.instagram.com/shopee_mx',
    co: 'https://www.instagram.com/shopee_co',
    cl: 'https://www.instagram.com/shopee_cl',
};
/**
 * facebook app id
 * 用于成效分析 (https://developers.facebook.com/docs/sharing/webmasters#markup)
 * 但未使用此功能, 因此不需要加也可以, 不影响
 */
const FB_APP_ID_ALL = {
    sg: '1574354049466790',
    tw: '382498665271383',
    my: '717399095044843',
    id: '957549474255294',
    ph: '437897333028638',
    vn: '421039428061656',
    th: '721805524607838',
    br: '484889158765114',
    mx: '103487065092294',
    co: '',
    cl: '',
};
const INS_HOMEPAGE = INS_HOMEPAGE_ALL[cid];
const FB_APP_ID = FB_APP_ID_ALL[cid];

export { FB_APP_ID, FB_APP_ID_ALL, INS_HOMEPAGE, INS_HOMEPAGE_ALL };
